exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */::ng-deep .grid-row-text-overlay{padding-left:45px}.date-filter{justify-content:space-between}.date-filter .reset-btn{margin-right:30px}.main-search-field{margin-right:40px}.pre-created-filter{font-size:15px;width:180px}.pre-created-filter .mat-form-field.field{min-width:180px}.recalculate mat-icon{transform:scale(-1, 1)}", ""]);

// exports
